import React from "react";
import Video from "./Video";

class VideoGallery extends React.Component {

    componentDidMount() {
        console.log(this.props);
    }

    render() {

        return (
          <section className="rob-video__gallery">
              <div className="container">
                  {this.props.videos.map(function (name, index) {
                      return  <Video key={index} {...name} />
                  })
                  }
              </div>
          </section>
        )
    }

}

VideoGallery.defaultProps = {videos: []};


export default VideoGallery;




// WEBPACK FOOTER //
// ./src/components/elements/blockLoop/VideoGallery.js